import React from "react";
import { Helmet } from "react-helmet";

const MetaTags = () => {
  return (
    <Helmet>
      {/* HTML Meta Tags */}
      <title>Ecoil - Pure & Natural Oil</title>
      <meta name="description" content="Buy 100% pure and natural oils from Ecoil. Quality you can trust!" />

      {/* Facebook Meta Tags */}
      <meta property="og:url" content="https://ecoil.in/" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Ecoil - 100% Pure & Natural Oil" />
      <meta property="og:description" content="Get the best quality natural oils delivered to your doorstep!" />
      <meta property="og:image" content="https://ecoil.in/assets/images/og-image.jpg" />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="ecoil.in" />
      <meta property="twitter:url" content="https://ecoil.in/" />
      <meta name="twitter:title" content="Ecoil - Pure & Natural Oil" />
      <meta name="twitter:description" content="Buy 100% pure and natural oils from Ecoil. Quality you can trust!" />
      <meta name="twitter:image" content="https://ecoil.in/assets/images/twitter-image.jpg" />
    </Helmet>
  );
};

export default MetaTags;
